<div>
	<label
		*ngIf="currentLimitText"
		class="obg-m-deposit-limit-item-current-limit"
		test-id="deposit-limit-item-current-limit"
		data-test-id="deposit-limit-item-current-limit"
		>{{ currentLimitText | translate }}
		<span *ngIf="currentLimitValue; else limitNotSet">{{
			currentLimitValue | obgCurrency: undefined : undefined : "1.0-0"
		}}</span>

		<ng-template #limitNotSet>
			<span>{{ "general.not-set" | translate }}</span>
		</ng-template>
	</label>
	<div *ngIf="showInputField && control" class="obg-m-deposit-limit-item-input">
		<span [ngClass]="[iconName]"></span>

		<mat-form-field floatLabel="never">
			<span matPrefix *ngIf="prefixCurrencySymbol" class="obg-m-deposit-limit-item-currency-prefix"
				>{{ currencySymbol }}&nbsp;</span
			>

			<input
				matInput
				type="tel"
				autocomplete="off"
				[formControl]="control"
				[placeholder]="placeholder | translate"
				[autofocus]="autoFocus"
				#depositInput
				[attr.test-id]="suggestionTestId + '-input'"
				[attr.data-test-id]="suggestionTestId + '-input'"
				cdkFocusInitial
			/>

			<span *ngIf="!prefixCurrencySymbol" class="obg-m-deposit-limit-item-currency">{{ currencySymbol }}</span>
			<mat-hint
				*ngIf="limitSuggestion && !(control.invalid && (control.touched || control.dirty)) && !hideInputHint"
				attr.test-id="{{ suggestionTestId }}"
			>
				*{{ "multi-deposit-limit.suggestion" | translate }}: {{ limitSuggestion }} {{ currencySymbol }}
			</mat-hint>
		</mat-form-field>

		<obg-common-validation-renderer
			*ngIf="!hideValidator"
			[input]="control"
			[translationArguments]="depositLimitTranslationArguments"
			[translationPrefix]="translationPrefix"
		>
		</obg-common-validation-renderer>
	</div>
	<ng-content></ng-content>
</div>
